function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
export var normalizeTeams = function normalizeTeams(_ref) {
  var favoriteId = _ref.favoriteId,
    followedTeams = _ref.followedTeams,
    followLabel = _ref.followLabel,
    followingLabel = _ref.followingLabel,
    teams = _ref.teams;
  if (!(teams !== null && teams !== void 0 && teams.length)) {
    return null;
  }
  var favoriteTeam = teams.find(function (team) {
    var _team$id;
    return ((_team$id = team.id) === null || _team$id === void 0 ? void 0 : _team$id.toString()) === (favoriteId === null || favoriteId === void 0 ? void 0 : favoriteId.toString());
  });
  /**
   * If we also want to move followedTeams to the top, commented code will achieve that.
   */
  // const followedTeamsPlucked = [];

  // Create Set of followedTeam ids for easy matching
  var followedTeamsSet = new Set();
  followedTeams === null || followedTeams === void 0 ? void 0 : followedTeams.forEach(function (_ref2) {
    var id = _ref2.id;
    followedTeamsSet.add("".concat(id));
    // followedTeamsPlucked.push(
    //   teams.find((team) => team.id?.toString() === id.toString())
    // );
  });

  var remainingTeams = teams
  //won't be necessary once statsapi is updated
  .map(function (team) {
    return team.franchiseName === "Oakland" ? _objectSpread(_objectSpread({}, team), {}, {
      franchiseName: "Athletics"
    }) : team;
  }).filter(function (team) {
    var _team$id2;
    return !(((_team$id2 = team.id) === null || _team$id2 === void 0 ? void 0 : _team$id2.toString()) === (favoriteId === null || favoriteId === void 0 ? void 0 : favoriteId.toString()));
  } // || followedTeamsSet.has(`${id}`))
  ).sort(function (a, b) {
    return a.franchiseName.localeCompare(b.franchiseName);
  });
  var reorderedTeams = [].concat(_toConsumableArray(favoriteTeam ? [favoriteTeam] : []), _toConsumableArray(remainingTeams || []));
  return reorderedTeams === null || reorderedTeams === void 0 ? void 0 : reorderedTeams.map(function (_ref3) {
    var abbreviation = _ref3.abbreviation,
      clubName = _ref3.clubName,
      franchiseName = _ref3.franchiseName,
      id = _ref3.id;
    var isFollowed = followedTeamsSet.has("".concat(id));
    return {
      abbreviation: abbreviation,
      alt: "".concat(franchiseName, " ").concat(clubName, " logo"),
      followLabel: isFollowed ? followingLabel : followLabel,
      id: id,
      isFollowed: isFollowed,
      name: clubName,
      superName: franchiseName,
      type: "team"
    };
  });
};
export var normalizeSearchResults = function normalizeSearchResults(_ref4) {
  var _players$slice;
  var followedPlayers = _ref4.followedPlayers,
    followedTeams = _ref4.followedTeams,
    followLabel = _ref4.followLabel,
    followingLabel = _ref4.followingLabel,
    players = _ref4.players,
    teams = _ref4.teams;
  // Create Set of followedTeam ids for easy matching
  var followedTeamsSet = new Set();
  followedTeams === null || followedTeams === void 0 ? void 0 : followedTeams.forEach(function (_ref5) {
    var id = _ref5.id;
    return followedTeamsSet.add("".concat(id));
  });
  var normalizedTeams = teams === null || teams === void 0 ? void 0 : teams.map(function (_ref6) {
    var clubName = _ref6.clubName,
      franchiseName = _ref6.franchiseName,
      teamId = _ref6.teamId,
      triCode = _ref6.triCode;
    var isFollowed = followedTeamsSet.has("".concat(teamId));
    return {
      abbreviation: triCode,
      alt: "".concat(franchiseName, " ").concat(clubName, " logo"),
      context: "typeahead",
      followLabel: isFollowed ? followingLabel : followLabel,
      id: teamId,
      isFollowed: isFollowed,
      name: clubName,
      superName: franchiseName === "Oakland" || franchiseName === "Athletics" ? "" : franchiseName,
      type: "team"
    };
  });

  // Create Set of followedPlayer ids for easy matching
  var followedPlayersSet = new Set();
  followedPlayers === null || followedPlayers === void 0 ? void 0 : followedPlayers.forEach(function (_ref7) {
    var id = _ref7.id;
    return followedPlayersSet.add("".concat(id));
  });
  var normalizedPlayers = players === null || players === void 0 ? void 0 : (_players$slice = players.slice(0, 25)) === null || _players$slice === void 0 ? void 0 : _players$slice.map(function (_ref8) {
    var boxscoreName = _ref8.boxscoreName,
      playerId = _ref8.playerId,
      useLastName = _ref8.useLastName,
      useName = _ref8.useName;
    var isFollowed = followedPlayersSet.has("".concat(playerId));
    return {
      alt: "".concat(useName, " ").concat(useLastName || boxscoreName, " headshot"),
      context: "typeahead",
      followLabel: isFollowed ? followingLabel : followLabel,
      id: playerId,
      isFollowed: isFollowed,
      name: useLastName || boxscoreName,
      superName: useName,
      type: "player"
    };
  });
  return [].concat(_toConsumableArray(normalizedTeams || []), _toConsumableArray(normalizedPlayers || []));
};